/**
 * @callback Accessor
 * @param {State} state
 * @return {any}
 */

import device from './device';
import app from './app';
import video from './video';
import renderZones from './renderZones';
import userSlice from './user';
/*

		TODO: Choose one method **or/and** place to define and store all accessors.
			For the now it sometimes defined here, sometimes in entities folders,
			sometime with DI.
			Absolutely messed and not appropriate.

 */

export default {
  app,
  device,
  video,
  renderZones,
  userSlice,
};
